export default __webpack_public_path__ + "static/media/i_bus-dbl_rd_dup.d0e63914.svg";